import { canSurveyActivateRepeatedly } from "@posthog/core/surveys";
import { isNumber } from "@posthog/core";
import { SURVEYS_ACTIVATED, SURVEYS_ACTIVATED_SESSION, SURVEYS_ACTIVATED_TIMESTAMPS } from "./surveys-config.mjs";
import { SurveyEventName } from "./survey-constants.mjs";
import { SURVEY_LOGGER } from "./utils/survey-utils.mjs";
import { EventReceiver } from "./survey-event-receiver-base.mjs";
class SurveyEventReceiver extends EventReceiver {
    constructor(_client, _surveys, actions, onActivationChanged){
        super({
            subscribeCapture: (listener)=>{
                const subscription = _client.onEvent((event)=>listener(event.event, event));
                return ()=>subscription.dispose();
            },
            subscribeSession: (listener)=>{
                const subscription = _client.onSession(listener);
                return ()=>subscription.dispose();
            },
            getSessionId: ()=>_client.session?.sessionId,
            getProperty: (key)=>_client.kv.get(key),
            getActionUrl: actions?.getActionUrl,
            setElementSelectors: actions?.setElementSelectors ?? ((selectors, owner)=>_client.getExtension('autocapture')?.setElementSelectors(selectors, owner))
        }, onActivationChanged), this._client = _client, this._surveys = _surveys;
        this._subscribeSession();
    }
    _getActivatedKey() {
        return SURVEYS_ACTIVATED;
    }
    _getActivatedSessionKey() {
        return SURVEYS_ACTIVATED_SESSION;
    }
    _getActivationTimestampsKey() {
        return SURVEYS_ACTIVATED_TIMESTAMPS;
    }
    _writeActivationTimestamps(timestamps) {
        this._client.kv.set({
            [SURVEYS_ACTIVATED_TIMESTAMPS]: timestamps
        });
    }
    _clearActivationTimestampsStore() {
        this._client.kv.remove(SURVEYS_ACTIVATED_TIMESTAMPS);
    }
    _shouldPersistArmedActivation(itemId) {
        let survey;
        this._getItems((surveys)=>{
            survey = surveys.find((s)=>s.id === itemId);
        });
        const delaySeconds = survey?.appearance?.surveyPopupDelaySeconds;
        return isNumber(delaySeconds) && delaySeconds > 0;
    }
    _getShownEventName() {
        return SurveyEventName.SHOWN;
    }
    _getItems(callback) {
        this._surveys.getSurveys(callback);
    }
    _cancelPendingItem(itemId) {
        this._surveys.cancelPendingSurvey(itemId);
    }
    _getLogger() {
        return SURVEY_LOGGER;
    }
    _setActivatedItems(eligibleItems) {
        this._client.kv.set({
            [SURVEYS_ACTIVATED]: eligibleItems
        });
    }
    _setActivatedSession(sessionId) {
        this._client.kv.set({
            [SURVEYS_ACTIVATED_SESSION]: sessionId
        });
    }
    _clearActivatedSession() {
        this._client.kv.remove(SURVEYS_ACTIVATED_SESSION);
    }
    _isItemPermanentlyIneligible() {
        return false;
    }
    _activationOutcome(event, itemId, eventPayload) {
        if (event === SurveyEventName.SENT && eventPayload?.properties?.$survey_completed === false) return 'ignore';
        let survey;
        this._getItems((surveys)=>{
            survey = surveys.find((s)=>s.id === itemId);
        });
        const consumedOnShown = !survey || canSurveyActivateRepeatedly(survey);
        if (consumedOnShown) return event === SurveyEventName.SHOWN ? 'consume' : 'ignore';
        if (event === SurveyEventName.SHOWN) return 'persist';
        return event === SurveyEventName.DISMISSED || event === SurveyEventName.SENT ? 'consume' : 'ignore';
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}
export { SurveyEventReceiver };
